module.exports = __webpack_public_path__ + "static/media/corporateStep6.3433a9e2.svg";